export default class Task
{
  constructor(name, notes, tools) 
  {
    this.name = name;
    this.notes = notes;
    this.tools = tools;
  }    

  isValid()
  {
    return this.name;
  }
}